/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

import moduleOrders from "./orders/moduleOrders"
import moduleAuth from "./auth/moduleAuth"
import moduleContactForm from "./contact-forms/moduleContactForm"
import moduleAnalytics from "./analytics/moduleAnalytics"
import moduleProducts from "./products/moduleProducts"

Vue.use(Vuex)

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
      orders: moduleOrders,
      auth: moduleAuth,
      contactForm: moduleContactForm,
      analytics: moduleAnalytics,
      products: moduleProducts
    },
    strict: process.env.NODE_ENV !== 'production'
})
